import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { DiversionsReviewForm } from '@ruby/modules/diversions/forms/review/form/diversions-review.form';
import { DiversionsPrivateCarReviewForm } from '@ruby/modules/diversions/forms/review/private-car/diversions.private-car-review.form';
import { DiversionsRequestReviewForm } from '@ruby/modules/diversions/forms/review/request/diversions.request-review.form';
import { DiversionsReshipReviewForm } from '@ruby/modules/diversions/forms/review/reship/diversions.reship-review.form';
import { DiversionsSubmitForm } from '@ruby/modules/diversions/forms/review/submit/diversions-submit.form';
import { DiversionsTurnoverReviewForm } from '@ruby/modules/diversions/forms/review/turnover/diversions-turnover.form';

@NgModule({
  declarations: [
    DiversionsReviewForm,
    DiversionsSubmitForm,
    DiversionsRequestReviewForm,
    DiversionsPrivateCarReviewForm,
    DiversionsTurnoverReviewForm,
    DiversionsReshipReviewForm
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    NSSkeletonModule,
    NSGridModule
  ],
  exports: [
    DiversionsReviewForm,
    DiversionsSubmitForm,
    DiversionsRequestReviewForm,
    DiversionsPrivateCarReviewForm,
    DiversionsTurnoverReviewForm
  ]
})
export class DiversionsReviewModule {}
